import React from 'react';

interface SVGProps extends React.SVGProps<SVGSVGElement> {
  onClick?: () => void;
  className?: string;
}

// stroke defaults to the Analytics page's green; callers can override it.
export const DownloadIcon: React.FC<SVGProps> = ({
  stroke = '#20E086',
  ...props
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
      stroke={stroke}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66699 6.66699L8.00033 10.0003L11.3337 6.66699"
      stroke={stroke}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10V2"
      stroke={stroke}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.6667V8"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.33331H8.00667"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronDownIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 6L8 10L12 6"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PremiumIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14.642L13.925 15.792C14.1083 15.9087 14.2877 15.9047 14.463 15.78C14.6383 15.6553 14.7007 15.4843 14.65 15.267L14.15 13.092L15.85 11.617C16.0167 11.467 16.0667 11.288 16 11.08C15.9333 10.872 15.7833 10.7593 15.55 10.742L13.325 10.567L12.45 8.49199C12.3667 8.29199 12.2167 8.19199 12 8.19199C11.7833 8.19199 11.6333 8.29199 11.55 8.49199L10.675 10.567L8.45 10.742C8.21667 10.7587 8.06667 10.8713 8 11.08C7.93333 11.2887 7.98333 11.4677 8.15 11.617L9.85 13.092L9.35 15.267C9.3 15.4837 9.36267 15.6547 9.538 15.78C9.71333 15.9053 9.89233 15.9093 10.075 15.792L12 14.642ZM8.65 20.167H6C5.45 20.167 4.97933 19.9713 4.588 19.58C4.19667 19.1887 4.00067 18.7177 4 18.167V15.517L2.075 13.567C1.89167 13.367 1.75 13.1463 1.65 12.905C1.55 12.6637 1.5 12.4177 1.5 12.167C1.5 11.9163 1.55 11.6707 1.65 11.43C1.75 11.1893 1.89167 10.9683 2.075 10.767L4 8.81699V6.16699C4 5.61699 4.196 5.14633 4.588 4.75499C4.98 4.36366 5.45067 4.16766 6 4.16699H8.65L10.6 2.24199C10.8 2.05866 11.021 1.91699 11.263 1.81699C11.505 1.71699 11.7507 1.66699 12 1.66699C12.2493 1.66699 12.4953 1.71699 12.738 1.81699C12.9807 1.91699 13.2013 2.05866 13.4 2.24199L15.35 4.16699H18C18.55 4.16699 19.021 4.36299 19.413 4.75499C19.805 5.14699 20.0007 5.61766 20 6.16699V8.81699L21.925 10.767C22.1083 10.967 22.25 11.188 22.35 11.43C22.45 11.672 22.5 11.9177 22.5 12.167C22.5 12.4163 22.45 12.6623 22.35 12.905C22.25 13.1477 22.1083 13.3683 21.925 13.567L20 15.517V18.167C20 18.717 19.8043 19.188 19.413 19.58C19.0217 19.972 18.5507 20.1677 18 20.167H15.35L13.4 22.092C13.2 22.2753 12.9793 22.417 12.738 22.517C12.4967 22.617 12.2507 22.667 12 22.667C11.7493 22.667 11.5037 22.617 11.263 22.517C11.0223 22.417 10.8013 22.2753 10.6 22.092L8.65 20.167Z"
        fill="#FFD700"
      />
    </svg>
  );
};

export const ImageThumbnailIcon: React.FC<SVGProps> = (props) => (
  // <svg
  //   width="16"
  //   height="16"
  //   viewBox="0 0 16 16"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <rect
  //     x="2"
  //     y="2"
  //     width="12"
  //     height="12"
  //     rx="2"
  //     stroke="currentColor"
  //     strokeWidth="1.33333"
  //   />
  //   <circle cx="5.33333" cy="5.33333" r="1.33333" fill="currentColor" />
  //   <path
  //     d="M2 10.6667L5.33333 7.33333L14 16"
  //     stroke="currentColor"
  //     strokeWidth="1.33333"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M9.33301 8.66667L13.9997 4"
  //     stroke="currentColor"
  //     strokeWidth="1.33333"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  // </svg>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4075_18331)">
      <path
        d="M7.272 72.5635C5.199 72.5635 3.4695 71.8608 2.0835 70.4556C0.697499 69.0503 0.003 67.2953 0 65.1905V6.93648C0 4.83469 0.694499 3.08116 2.0835 1.67591C3.4725 0.270663 5.202 -0.433482 7.272 -0.436523H64.7325C66.8025 -0.436523 68.532 0.267621 69.921 1.67591C71.31 3.0842 72.003 4.83773 72 6.93648V65.195C72 67.2938 71.307 69.0473 69.921 70.4556C68.535 71.8639 66.804 72.5665 64.728 72.5635H7.272ZM7.272 68.001H64.7325C65.4225 68.001 66.057 67.709 66.636 67.125C67.215 66.541 67.503 65.8961 67.5 65.1905V6.93648C67.5 6.23385 67.212 5.58902 66.636 5.00198C66.06 4.41493 65.424 4.12293 64.728 4.12598H7.272C6.579 4.12598 5.943 4.41798 5.364 5.00198C4.785 5.58598 4.497 6.23081 4.5 6.93648V65.195C4.5 65.8946 4.788 66.5379 5.364 67.125C5.94 67.712 6.5745 68.004 7.2675 68.001M15.75 56.5947H56.943L44.2215 39.3941L32.454 54.4868L24.579 44.8372L15.75 56.5947Z"
        fill="#B9C0C5"
      />
    </g>
    <defs>
      <clipPath id="clip0_4075_18331">
        <rect width="72" height="72" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DropIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 6L8 10L12 6"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UnlockIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="3"
      y="7"
      width="10"
      height="7"
      rx="1"
      stroke="currentColor"
      strokeWidth="1.33333"
    />
    <path
      d="M11 7V4.5C11 2.567 9.433 1 7.5 1V1C5.567 1 4 2.567 4 4.5V7"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
    />
    <circle cx="8" cy="10" r="1" fill="currentColor" />
  </svg>
);

// Ajout des icônes manquantes

export const UploadImageIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3337 5.33366L8.00033 2.00033L4.66699 5.33366"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2V10"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Arrow: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 12L8 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 8L8 4L12 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightArrow: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 8H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 4L12 8L8 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftArrow: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 8H4"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 4L4 8L8 12"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronUpIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 10L8 6L12 10"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckCircleIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6668 7.38666V8.00666C14.6654 9.43863 14.2005 10.8364 13.3392 11.9879C12.4778 13.1393 11.2679 13.9817 9.8904 14.3893C8.51296 14.7969 7.03806 14.7479 5.68963 14.2493C4.3412 13.7507 3.18992 12.8308 2.40747 11.6248C1.62501 10.4188 1.25336 8.99211 1.34795 7.55764C1.44254 6.12318 1.9983 4.7575 2.93235 3.66473C3.8664 2.57196 5.12869 1.81033 6.53096 1.49343C7.93322 1.17654 9.40034 1.32163 10.7135 1.90666"
      stroke="#4ADE80"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 2.66666L8 9.33999L6 7.33999"
      stroke="#4ADE80"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DashedCircleIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="8"
      cy="8"
      r="7"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeDasharray="4 4"
    />
  </svg>
);

export const DeleteIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 4H3.33333H14"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 4.00001V2.66668C5.33301 2.31305 5.47348 1.97392 5.72353 1.72387C5.97358 1.47382 6.31272 1.33334 6.66634 1.33334H9.33301C9.68663 1.33334 10.0258 1.47382 10.2758 1.72387C10.5259 1.97392 10.6663 2.31305 10.6663 2.66668V4.00001M12.6663 4.00001V13.3333C12.6663 13.687 12.5259 14.0261 12.2758 14.2762C12.0258 14.5262 11.6866 14.6667 11.333 14.6667H4.66634C4.31272 14.6667 3.97358 14.5262 3.72353 14.2762C3.47348 14.0261 3.33301 13.687 3.33301 13.3333V4.00001H12.6663Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 7.33334V11.3333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33301 7.33334V11.3333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14L11.1 11.1"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NumberOne = ({ fill = '#64449E', textColor = 'white' }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.27 20.4528C44.5314 19.9086 43.6002 19.2282 43.488 18.7836C43.5348 17.9226 43.7808 17.0856 44.2056 16.3356C44.8566 14.841 45.5286 13.2924 44.7816 12.0048C44.034 10.7172 42.3354 10.5084 40.7016 10.335C39.855 10.329 39.0204 10.1304 38.262 9.753C37.884 8.9916 37.6854 8.154 37.6824 7.305C37.4988 5.6706 37.308 3.9798 36.012 3.225C34.7166 2.469 33.1662 3.1308 31.6722 3.7902C30.9216 4.2144 30.0828 4.4604 29.2218 4.5078C28.7718 4.3872 28.0932 3.4644 27.5526 2.7258C26.604 1.4478 25.539 0 23.9988 0C22.4586 0 21.3924 1.4484 20.451 2.7258C19.9044 3.4662 19.2258 4.395 18.7812 4.5102C17.9214 4.458 17.0832 4.2126 16.3314 3.792C14.829 3.1302 13.2804 2.4708 11.997 3.2142C10.7136 3.957 10.4988 5.6598 10.3152 7.3044C10.3092 8.151 10.1112 8.9856 9.735 9.7446C8.9784 10.1166 8.1468 10.3116 7.3038 10.3164C5.6676 10.5 3.975 10.6896 3.222 11.9856C2.4684 13.2816 3.1302 14.8308 3.7896 16.3272C4.2156 17.079 4.4616 17.9202 4.5078 18.7836C4.3866 19.2342 3.4638 19.9146 2.7258 20.4528C1.4472 21.3924 0 22.461 0 24.0012C0 25.5414 1.4484 26.61 2.7276 27.549C3.4662 28.0938 4.3968 28.7742 4.5096 29.2188C4.4622 30.0792 4.2168 30.9168 3.792 31.6668C3.141 33.1608 2.469 34.7094 3.216 35.9976C3.963 37.2852 5.6616 37.494 7.296 37.6668C8.1426 37.6728 8.9772 37.872 9.735 38.2488C10.113 39.0108 10.3116 39.8478 10.3152 40.6974C10.4988 42.3318 10.689 44.022 11.985 44.7774C13.281 45.5334 14.8188 44.853 16.3152 44.2014C17.073 43.7814 17.9166 43.5396 18.7818 43.4922C19.2324 43.6134 19.911 44.5356 20.4516 45.2742C21.3924 46.5522 22.4592 48 23.9988 48C25.539 48 26.6052 46.5516 27.5466 45.2742C28.0932 44.5338 28.7718 43.605 29.2164 43.4904C30.0768 43.539 30.915 43.7838 31.6662 44.208C33.1596 44.859 34.7076 45.5268 35.994 44.7858C37.2798 44.0454 37.4928 42.3402 37.6764 40.704C37.6824 39.8568 37.8804 39.0228 38.2566 38.2644C39.0144 37.8894 39.8478 37.6914 40.6938 37.686C42.33 37.5024 44.0226 37.3122 44.7756 36.0162C45.5292 34.7202 44.8488 33.1818 44.1996 31.6854C43.7748 30.9294 43.5318 30.0852 43.4904 29.2188C43.6104 28.7682 44.5332 28.0884 45.2724 27.549C46.5498 26.6076 48 25.5396 48 24.0012C48 22.4628 46.5492 21.3924 45.27 20.4528Z"
        fill={fill}
      />
      <path
        d="M27.0114 12.7273V36H22.0909V17.3977H21.9545L16.625 20.7386V16.375L22.3864 12.7273H27.0114Z"
        fill={textColor}
      />
    </svg>
  );
};

export const NumberTwo = ({ fill = '#64449E', textColor = 'white' }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.27 20.4528C44.5314 19.9086 43.6002 19.2282 43.488 18.7836C43.5348 17.9226 43.7808 17.0856 44.2056 16.3356C44.8566 14.841 45.5286 13.2924 44.7816 12.0048C44.034 10.7172 42.3354 10.5084 40.7016 10.335C39.855 10.329 39.0204 10.1304 38.262 9.753C37.884 8.9916 37.6854 8.154 37.6824 7.305C37.4988 5.6706 37.308 3.9798 36.012 3.225C34.7166 2.469 33.1662 3.1308 31.6722 3.7902C30.9216 4.2144 30.0828 4.4604 29.2218 4.5078C28.7718 4.3872 28.0932 3.4644 27.5526 2.7258C26.604 1.4478 25.539 0 23.9988 0C22.4586 0 21.3924 1.4484 20.451 2.7258C19.9044 3.4662 19.2258 4.395 18.7812 4.5102C17.9214 4.458 17.0832 4.2126 16.3314 3.792C14.829 3.1302 13.2804 2.4708 11.997 3.2142C10.7136 3.957 10.4988 5.6598 10.3152 7.3044C10.3092 8.151 10.1112 8.9856 9.735 9.7446C8.9784 10.1166 8.1468 10.3116 7.3038 10.3164C5.6676 10.5 3.975 10.6896 3.222 11.9856C2.4684 13.2816 3.1302 14.8308 3.7896 16.3272C4.2156 17.079 4.4616 17.9202 4.5078 18.7836C4.3866 19.2342 3.4638 19.9146 2.7258 20.4528C1.4472 21.3924 0 22.461 0 24.0012C0 25.5414 1.4484 26.61 2.7276 27.549C3.4662 28.0938 4.3968 28.7742 4.5096 29.2188C4.4622 30.0792 4.2168 30.9168 3.792 31.6668C3.141 33.1608 2.469 34.7094 3.216 35.9976C3.963 37.2852 5.6616 37.494 7.296 37.6668C8.1426 37.6728 8.9772 37.872 9.735 38.2488C10.113 39.0108 10.3116 39.8478 10.3152 40.6974C10.4988 42.3318 10.689 44.022 11.985 44.7774C13.281 45.5334 14.8188 44.853 16.3152 44.2014C17.073 43.7814 17.9166 43.5396 18.7818 43.4922C19.2324 43.6134 19.911 44.5356 20.4516 45.2742C21.3924 46.5522 22.4592 48 23.9988 48C25.539 48 26.6052 46.5516 27.5466 45.2742C28.0932 44.5338 28.7718 43.605 29.2164 43.4904C30.0768 43.539 30.915 43.7838 31.6662 44.208C33.1596 44.859 34.7076 45.5268 35.994 44.7858C37.2798 44.0454 37.4928 42.3402 37.6764 40.704C37.6824 39.8568 37.8804 39.0228 38.2566 38.2644C39.0144 37.8894 39.8478 37.6914 40.6938 37.686C42.33 37.5024 44.0226 37.3122 44.7756 36.0162C45.5292 34.7202 44.8488 33.1818 44.1996 31.6854C43.7748 30.9294 43.5318 30.0852 43.4904 29.2188C43.6104 28.7682 44.5332 28.0884 45.2724 27.549C46.5498 26.6076 48 25.5396 48 24.0012C48 22.4628 46.5492 21.3924 45.27 20.4528Z"
        fill={fill}
      />
      <path
        d="M15.8082 36V32.4545L24.0923 24.7841C24.7969 24.1023 25.3878 23.4886 25.8651 22.9432C26.3499 22.3977 26.7173 21.8636 26.9673 21.3409C27.2173 20.8106 27.3423 20.2386 27.3423 19.625C27.3423 18.9432 27.187 18.3561 26.8764 17.8636C26.5658 17.3636 26.1416 16.9811 25.6037 16.7159C25.0658 16.4432 24.456 16.3068 23.7741 16.3068C23.062 16.3068 22.4408 16.4508 21.9105 16.7386C21.3802 17.0265 20.9711 17.4394 20.6832 17.9773C20.3954 18.5152 20.2514 19.1553 20.2514 19.8977H15.581C15.581 18.375 15.9257 17.053 16.6151 15.9318C17.3045 14.8106 18.2704 13.9432 19.5128 13.3295C20.7552 12.7159 22.187 12.4091 23.8082 12.4091C25.4749 12.4091 26.9257 12.7045 28.1605 13.2955C29.4029 13.8788 30.3688 14.6894 31.0582 15.7273C31.7476 16.7652 32.0923 17.9545 32.0923 19.2955C32.0923 20.1742 31.9181 21.0417 31.5696 21.8977C31.2287 22.7538 30.6188 23.7045 29.7401 24.75C28.8613 25.7879 27.6226 27.0341 26.0241 28.4886L22.6264 31.8182V31.9773H32.3991V36H15.8082Z"
        fill={textColor}
      />
    </svg>
  );
};

export const NumberThree = ({ fill = '#64449E', textColor = 'white' }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.27 20.4528C44.5314 19.9086 43.6002 19.2282 43.488 18.7836C43.5348 17.9226 43.7808 17.0856 44.2056 16.3356C44.8566 14.841 45.5286 13.2924 44.7816 12.0048C44.034 10.7172 42.3354 10.5084 40.7016 10.335C39.855 10.329 39.0204 10.1304 38.262 9.753C37.884 8.9916 37.6854 8.154 37.6824 7.305C37.4988 5.6706 37.308 3.9798 36.012 3.225C34.7166 2.469 33.1662 3.1308 31.6722 3.7902C30.9216 4.2144 30.0828 4.4604 29.2218 4.5078C28.7718 4.3872 28.0932 3.4644 27.5526 2.7258C26.604 1.4478 25.539 0 23.9988 0C22.4586 0 21.3924 1.4484 20.451 2.7258C19.9044 3.4662 19.2258 4.395 18.7812 4.5102C17.9214 4.458 17.0832 4.2126 16.3314 3.792C14.829 3.1302 13.2804 2.4708 11.997 3.2142C10.7136 3.957 10.4988 5.6598 10.3152 7.3044C10.3092 8.151 10.1112 8.9856 9.735 9.7446C8.9784 10.1166 8.1468 10.3116 7.3038 10.3164C5.6676 10.5 3.975 10.6896 3.222 11.9856C2.4684 13.2816 3.1302 14.8308 3.7896 16.3272C4.2156 17.079 4.4616 17.9202 4.5078 18.7836C4.3866 19.2342 3.4638 19.9146 2.7258 20.4528C1.4472 21.3924 0 22.461 0 24.0012C0 25.5414 1.4484 26.61 2.7276 27.549C3.4662 28.0938 4.3968 28.7742 4.5096 29.2188C4.4622 30.0792 4.2168 30.9168 3.792 31.6668C3.141 33.1608 2.469 34.7094 3.216 35.9976C3.963 37.2852 5.6616 37.494 7.296 37.6668C8.1426 37.6728 8.9772 37.872 9.735 38.2488C10.113 39.0108 10.3116 39.8478 10.3152 40.6974C10.4988 42.3318 10.689 44.022 11.985 44.7774C13.281 45.5334 14.8188 44.853 16.3152 44.2014C17.073 43.7814 17.9166 43.5396 18.7818 43.4922C19.2324 43.6134 19.911 44.5356 20.4516 45.2742C21.3924 46.5522 22.4592 48 23.9988 48C25.539 48 26.6052 46.5516 27.5466 45.2742C28.0932 44.5338 28.7718 43.605 29.2164 43.4904C30.0768 43.539 30.915 43.7838 31.6662 44.208C33.1596 44.859 34.7076 45.5268 35.994 44.7858C37.2798 44.0454 37.4928 42.3402 37.6764 40.704C37.6824 39.8568 37.8804 39.0228 38.2566 38.2644C39.0144 37.8894 39.8478 37.6914 40.6938 37.686C42.33 37.5024 44.0226 37.3122 44.7756 36.0162C45.5292 34.7202 44.8488 33.1818 44.1996 31.6854C43.7748 30.9294 43.5318 30.0852 43.4904 29.2188C43.6104 28.7682 44.5332 28.0884 45.2724 27.549C46.5498 26.6076 48 25.5396 48 24.0012C48 22.4628 46.5492 21.3924 45.27 20.4528Z"
        fill={fill}
      />
      <path
        d="M23.9418 36.3182C22.2448 36.3182 20.7334 36.0265 19.4077 35.4432C18.0895 34.8523 17.0478 34.0417 16.2827 33.0114C15.5251 31.9735 15.1349 30.7765 15.1122 29.4205H20.0668C20.0971 29.9886 20.2827 30.4886 20.6236 30.9205C20.9721 31.3447 21.4342 31.6742 22.0099 31.9091C22.5857 32.1439 23.2334 32.2614 23.9531 32.2614C24.7031 32.2614 25.366 32.1288 25.9418 31.8636C26.5175 31.5985 26.9683 31.2311 27.294 30.7614C27.6198 30.2917 27.7827 29.75 27.7827 29.1364C27.7827 28.5152 27.6084 27.9659 27.2599 27.4886C26.919 27.0038 26.4266 26.625 25.7827 26.3523C25.1463 26.0795 24.3887 25.9432 23.5099 25.9432H21.3395V22.3295H23.5099C24.2524 22.3295 24.9077 22.2008 25.4759 21.9432C26.0516 21.6856 26.4986 21.3295 26.8168 20.875C27.1349 20.4129 27.294 19.875 27.294 19.2614C27.294 18.678 27.1539 18.1667 26.8736 17.7273C26.6009 17.2803 26.2145 16.9318 25.7145 16.6818C25.2221 16.4318 24.6463 16.3068 23.9872 16.3068C23.3205 16.3068 22.7107 16.428 22.1577 16.6705C21.6046 16.9053 21.1615 17.2424 20.8281 17.6818C20.4948 18.1212 20.3168 18.6364 20.294 19.2273H15.5781C15.6009 17.8864 15.9834 16.7045 16.7259 15.6818C17.4683 14.6591 18.4683 13.8598 19.7259 13.2841C20.991 12.7008 22.419 12.4091 24.0099 12.4091C25.616 12.4091 27.0213 12.7008 28.2259 13.2841C29.4304 13.8674 30.366 14.6553 31.0327 15.6477C31.7069 16.6326 32.0402 17.7386 32.0327 18.9659C32.0402 20.2689 31.6349 21.3561 30.8168 22.2273C30.0062 23.0985 28.9493 23.6515 27.6463 23.8864V24.0682C29.3584 24.2879 30.6615 24.8826 31.5554 25.8523C32.4569 26.8144 32.9039 28.0189 32.8963 29.4659C32.9039 30.7917 32.5213 31.9697 31.7486 33C30.9834 34.0303 29.9266 34.8409 28.5781 35.4318C27.2296 36.0227 25.6842 36.3182 23.9418 36.3182Z"
        fill={textColor}
      />
    </svg>
  );
};

export const UpArrowWithWhiteBackground: React.FC<SVGProps> = (props) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="18" cy="18" r="18" fill="white" />
    <path
      d="M18 26L18 10"
      stroke="#4F46E5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 18L18 10L26 18"
      stroke="#4F46E5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const YouTubeIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.5401 6.42C22.4213 5.94541 22.1794 5.51057 21.8387 5.15941C21.4981 4.80824 21.0708 4.55318 20.6001 4.42C18.8801 4 12.0001 4 12.0001 4C12.0001 4 5.12008 4 3.40008 4.46C2.92933 4.59318 2.50205 4.84824 2.16139 5.19941C1.82073 5.55057 1.57879 5.98541 1.46008 6.46C1.14524 8.20556 0.991566 9.97631 1.00008 11.75C0.988351 13.537 1.14203 15.3213 1.46008 17.08C1.59046 17.5398 1.83681 17.9581 2.17512 18.2945C2.51344 18.6308 2.93428 18.8738 3.40008 19C5.12008 19.46 12.0001 19.46 12.0001 19.46C12.0001 19.46 18.8801 19.46 20.6001 19C21.0708 18.8668 21.4981 18.6118 21.8387 18.2606C22.1794 17.9094 22.4213 17.4746 22.5401 17C22.8529 15.2676 23.0064 13.5103 23.0001 11.75C23.0118 9.96295 22.8581 8.1787 22.5401 6.42Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 15.02L15.5 11.75L9.75 8.48V15.02Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SinglePersonIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3333 14V12.6667C13.3333 11.9594 13.0524 11.2811 12.5523 10.781C12.0522 10.281 11.3739 10 10.6667 10H5.33333C4.62609 10 3.94781 10.281 3.44771 10.781C2.94762 11.2811 2.66666 11.9594 2.66666 12.6667V14"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00001 7.33333C9.47277 7.33333 10.6667 6.13943 10.6667 4.66667C10.6667 3.19391 9.47277 2 8.00001 2C6.52725 2 5.33334 3.19391 5.33334 4.66667C5.33334 6.13943 6.52725 7.33333 8.00001 7.33333Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogoutIcon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 11.3333L14.0001 7.99996L10.6667 4.66663"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 8H6"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Link45Icon: React.FC<SVGProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="-1 -1 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.66667 8.66667C7.04422 9.05589 7.49963 9.36743 8.00364 9.58335C8.50765 9.79926 9.05103 9.91454 9.6 9.91981C10.149 9.92508 10.6949 9.82023 11.2033 9.61383C11.7117 9.40743 12.1732 9.10444 12.5583 8.72296L14.8917 6.38963C15.6609 5.59706 16.0845 4.53204 16.0741 3.42692C16.0637 2.32179 15.62 1.26502 14.8367 0.485973C14.0535 -0.293076 12.9967 -0.736719 11.8916 -0.726314C10.7865 -0.715909 9.7398 -0.251339 8.97083 0.546297L7.675 1.83546"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33333 7.33333C8.95578 6.94411 8.50037 6.63257 7.99636 6.41665C7.49235 6.20073 6.94897 6.08546 6.4 6.08019C5.85103 6.07492 5.30511 6.17977 4.79668 6.38617C4.28825 6.59257 3.82679 6.89556 3.44167 7.27704L1.10833 9.61037C0.339076 10.4029 -0.0844873 11.468 -0.0741392 12.5731C-0.0637911 13.6782 0.38004 14.735 1.16333 15.514C1.94662 16.2931 3.00342 16.7367 4.10846 16.7263C5.21351 16.7159 6.26019 16.2513 7.02917 15.4537L8.31667 14.1645"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowSmUpIcon: React.FC<SVGProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || 'w-5 h-5'}
    viewBox="0 0 20 20"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 6.414l-3.293 3.293a1 1 0 01-1.414 0z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10 18a1 1 0 01-1-1V9a1 1 0 112 0v8a1 1 0 01-1 1z"
      clipRule="evenodd"
    />
  </svg>
);

export const ArrowSmDownIcon: React.FC<SVGProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || 'w-5 h-5'}
    viewBox="0 0 20 20"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 13.586l3.293-3.293a1 1 0 011.414 0z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10 2a1 1 0 011 1v8a1 1 0 11-2 0V3a1 1 0 011-1z"
      clipRule="evenodd"
    />
  </svg>
);

export const MobileIcon: React.FC<SVGProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || 'w-5 h-5'}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
    <line x1="12" y1="18" x2="12" y2="18" />
  </svg>
);

export const TabletIcon: React.FC<SVGProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || 'w-5 h-5'}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
    <line x1="12" y1="18" x2="12" y2="18" />
  </svg>
);

export const DesktopIcon: React.FC<SVGProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.className || 'w-5 h-5'}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);

export const FacebookIcon: React.FC<SVGProps> = ({
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      className={className}
      onClick={onClick}
      {...props}
    >
      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
    </svg>
  );
};

export const InstagramIcon: React.FC<SVGProps> = ({
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      fill="currentColor"
      className={className}
      onClick={onClick}
      {...props}
    >
      <path d="M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 00-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z" />
    </svg>
  );
};

export const TwitterIcon: React.FC<SVGProps> = ({
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 15 15"
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.233 4.696c0-1.727 1.4-3.127 3.127-3.127 1.014 0 1.823.479 2.365 1.175a5.246 5.246 0 001.626-.629 2.634 2.634 0 01-1.148 1.45l.002.003a5.26 5.26 0 001.5-.413l-.001.002c-.337.505-.76.95-1.248 1.313.026.177.04.354.04.53 0 3.687-2.809 7.975-7.975 7.975a7.93 7.93 0 01-4.296-1.26.5.5 0 01-.108-.748.45.45 0 01.438-.215c.916.108 1.83-.004 2.637-.356a3.086 3.086 0 01-1.69-1.876.45.45 0 01.103-.448 3.07 3.07 0 01-1.045-2.31v-.034a.45.45 0 01.365-.442 3.068 3.068 0 01-.344-1.416c0-.468.003-1.058.332-1.59a.45.45 0 01.323-.208.5.5 0 01.538.161 6.964 6.964 0 004.46 2.507v-.044zm-1.712 7.279a6.936 6.936 0 01-2.249-.373 5.318 5.318 0 002.39-1.042.45.45 0 00-.27-.804 2.174 2.174 0 01-1.714-.888c.19-.015.376-.048.556-.096a.45.45 0 00-.028-.876 2.18 2.18 0 01-1.644-1.474c.2.048.409.077.623.084a.45.45 0 00.265-.824A2.177 2.177 0 012.48 3.87c0-.168.003-.317.013-.453a7.95 7.95 0 005.282 2.376.5.5 0 00.513-.61 2.127 2.127 0 012.071-2.614c1.234 0 2.136 1.143 2.136 2.432 0 3.256-2.476 6.974-6.975 6.974z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const WhatsappIcon: React.FC<SVGProps> = ({
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 16 16"
      className={className}
      onClick={onClick}
      {...props}
    >
      <path d="M13.601 2.326A7.854 7.854 0 007.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 003.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0013.6 2.326zM7.994 14.521a6.573 6.573 0 01-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 01-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 014.66 1.931 6.557 6.557 0 011.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 00-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
    </svg>
  );
};

export const EmailIcon: React.FC<SVGProps> = ({
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
      />
    </svg>
  );
};

export const ShareFilledIcon: React.FC<SVGProps> = ({
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      onClick={onClick}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M15.75 4.5a3 3 0 1 1 .825 2.066l-8.421 4.679a3.002 3.002 0 0 1 0 1.51l8.421 4.679a3 3 0 1 1-.729 1.31l-8.421-4.678a3 3 0 1 1 0-4.132l8.421-4.679a3 3 0 0 1-.096-.755Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const CopyIcon: React.FC<SVGProps> = ({
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      className={className}
      onClick={onClick}
      {...props}
    >
      <path d="M11 9 H20 A2 2 0 0 1 22 11 V20 A2 2 0 0 1 20 22 H11 A2 2 0 0 1 9 20 V11 A2 2 0 0 1 11 9 z" />
      <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
    </svg>
  );
};

export const AlertTriangle = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_660_3268)">
        <path
          d="M10.4516 4.02158L1.98155 18.1616C1.80692 18.464 1.71452 18.8069 1.71354 19.1561C1.71256 19.5053 1.80304 19.8487 1.97598 20.1521C2.14891 20.4555 2.39828 20.7083 2.69926 20.8854C3.00024 21.0625 3.34235 21.1577 3.69155 21.1616H20.6315C20.9808 21.1577 21.3229 21.0625 21.6238 20.8854C21.9248 20.7083 22.1742 20.4555 22.3471 20.1521C22.5201 19.8487 22.6105 19.5053 22.6096 19.1561C22.6086 18.8069 22.5162 18.464 22.3416 18.1616L13.8716 4.02158C13.6933 3.72769 13.4423 3.4847 13.1427 3.31607C12.8432 3.14743 12.5053 3.05884 12.1616 3.05884C11.8178 3.05884 11.4799 3.14743 11.1804 3.31607C10.8808 3.4847 10.6298 3.72769 10.4516 4.02158Z"
          stroke="#FF5912"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1616 9.16156V13.1616"
          stroke="#FF5912"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1616 17.1616H12.1716"
          stroke="#FF5912"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_660_3268">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.16156 0.16156)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ApprovedIcon = (props: any) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#84B200"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
};

export default ApprovedIcon;

export const PlusIcon = ({ stroke = 'currentColor' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19M5 12H19"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlertCircleIcon = ({ stroke = '#F59E0B' }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke={stroke} strokeWidth="2" />
      <path
        d="M12 8V12M12 16H12.01"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRightIcon = ({ stroke = 'currentColor' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 18L15 12L9 6"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
